import { render, staticRenderFns } from "./DeadlinesHandlerNew.vue?vue&type=template&id=ea93f376&scoped=true"
import script from "./DeadlinesHandlerNew.vue?vue&type=script&lang=js"
export * from "./DeadlinesHandlerNew.vue?vue&type=script&lang=js"
import style0 from "./DeadlinesHandlerNew.vue?vue&type=style&index=0&id=ea93f376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea93f376",
  null
  
)

export default component.exports